import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '【重要】年末年始のスケジュールについて',
    date: '2022.12.20',
    content: () => (
      <>
        <p>
          【ご案内】
          <br />
          平素よりD2Dサービスをご利用いただき、誠にありがとうございます。
          <br />
          年末年始のスケジュールは下記のとおり予定しております。
          <br />
          <br />
          尚、本件に関しご不明な点がございましたら、弊社営業担当までお問い合せ下さい。
          <br />
        </p>

        <p style={{ textAlign: 'center' }}>記</p>

        <p style={{ textAlign: 'end' }}>以上</p>
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    ...common.textGray700,
  },
  scheduleTableTitle: {
    ...common.textAlignCenter,
    ...common.textGray700,
    ...common.bigText,
    ...common.fontWeight600,
    padding: '22px 0px',
  },
  scheduleTableContainer: {
    ...common.flexColumn,
    padding: 28,
    border: `1px solid ${theme.palette.grey[700]}`,
    rowGap: '1rem',
  },
  scheduleTable: {
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'repeat(9, auto)',
    '& div': {
      ...common.textAlignCenter,
      padding: '10px 8px',
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
  },
}));

interface ScheduleTableProps {
  city: string;
  title: string;
  table: string[][];
}

const ScheduleTable = (props: ScheduleTableProps) => {
  const { city, title, table } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div>
      <div className={classes.scheduleTableTitle}>{title}</div>

      <div className={classes.scheduleTable}>
        <div></div>
        <div>{city}倉庫荷受けCUT日</div>
        <div>上海ETD</div>
        <div>東京ETA</div>
        <div>大阪ETA</div>
        <div>名古屋ETA</div>
        <div>博多ETA</div>
        <div>日本の最短納品日</div>
        <div>通関書類の締切</div>

        {table.map((row) => row.map((cell, i) => <div key={i}>{cell}</div>))}
      </div>
    </div>
  );
};

export const NewYear2023 = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title}>
      <Container>
        <div className={classes.title}>
          {strings.title}
          <br />
          <span className={classes.normalText}>{strings.date}</span>
        </div>
        <div className={classes.content}>{strings.content()}</div>

        <div className={classes.scheduleTableContainer}>
          <ScheduleTable
            city="上海"
            title="D2D航路 2022年年末期間 2022/12/26~2023/01/11"
            table={[
              [
                '上海',
                '2022/12/27',
                '2022/12/30',
                '2023/01/02',
                '',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '上海',
                '2022/12/27',
                '2022/12/30',
                '',
                '2023/01/02',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '上海',
                '2022/12/27',
                '2022/12/30',
                '',
                '',
                '2023/01/02',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '上海',
                '2022/12/28',
                '2022/12/31',
                '',
                '',
                '',
                '2023/01/02',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
            ]}
          />

          <ScheduleTable
            city="上海"
            title="D2D航路 2022年年末期間 2022/12/29~2023/01/13"
            table={[
              [
                '上海',
                '2022/12/30',
                '2023/01/02',
                '2023/01/05',
                '',
                '',
                '',
                '2023/01/12',
                '通関書類2023/1/5',
              ],
              [
                '上海',
                '2022/12/29',
                '2023/01/01',
                '',
                '2023/01/03',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '上海',
                '2022/12/29',
                '2023/01/01',
                '',
                '',
                '2023/01/04',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '上海',
                '2023/01/04',
                '2023/01/07',
                '',
                '',
                '',
                '2023/01/09',
                '2023/01/13',
                '1/13納品希望の場合、書類1/6',
              ],
            ]}
          />
        </div>

        <div style={{ height: 64 }} />

        <div className={classes.scheduleTableContainer}>
          <ScheduleTable
            city="広東"
            title="D2DSHENZHEN+航路 2022年年末期間 2022/12/26~2023/01/11"
            table={[
              [
                '広東',
                '2022/12/24',
                '2022/12/30',
                '2023/01/02',
                '',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '広東',
                '2022/12/24',
                '2022/12/30',
                '',
                '2023/01/02',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '広東',
                '2022/12/24',
                '2022/12/30',
                '',
                '',
                '2023/01/02',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '広東',
                '2022/12/24',
                '2022/12/31',
                '',
                '',
                '',
                '2023/01/02',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
            ]}
          />

          <ScheduleTable
            city="広東"
            title="D2D SHENZHEN+航路 2022年年末期間 2022/12/29~2023/01/13"
            table={[
              [
                '広東',
                '2022/12/26',
                '2023/01/02',
                '2023/01/05',
                '',
                '',
                '',
                '2023/01/12',
                '通関書類2023/1/5',
              ],
              [
                '広東',
                '2022/12/26',
                '2023/01/01',
                '',
                '2023/01/03',
                '',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '広東',
                '2022/12/26',
                '2023/01/01',
                '',
                '',
                '2023/01/04',
                '',
                '2023/01/11',
                '通関書類2023/1/5午前中',
              ],
              [
                '広東',
                '2022/12/26',
                '2023/01/07',
                '',
                '',
                '',
                '2023/01/09',
                '2023/01/13',
                '1/13納品希望の場合、書類1/6',
              ],
            ]}
          />
        </div>
      </Container>
    </Layout>
  );
};
